import { useTranslation } from '@thoughtspot/i18n';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useCreateRoleMutation, useGetPrivilegeGroupsQuery, useGetRoleByIdLazyQuery, useUpdateRoleMutation, } from "../../../../services/role/role-service";
import { getTranslatedInfoForMessageCode } from "../../../../utils/error-handling/error-strings-mapping";
import { getErrorCode } from '../../util';
import { getFlattenPrivilegesList, MODE, TranslationsKeys, } from '../util';
import { CreateEditForm } from './create-edit-form.container';
export var FIELD;
(function (FIELD) {
    FIELD["NAME"] = "name";
    FIELD["DESCRIPTION"] = "description";
})(FIELD || (FIELD = {}));
export const CreateEditModal = ({ isModalOpened, closeModal, isEditMode = false, setIsRefresh = _.noop, setIsLoading, successBannerMode, roleId = '', }) => {
    const { t } = useTranslation();
    const [isEditReady, setIsEditReady] = useState(false);
    const [filteredCheckboxData, setFilteredCheckboxData] = useState([]);
    const [privilegeIds, setPrivilegeIds] = useState([]);
    const [preSelectedPrivilegeIds, setPreSelectedPrivilegeIds] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const errorCB = () => {
        setErrorMessage(null);
    };
    const { data: privilegesList, error: privilegesListError, loading: privilegesListLoading, refetch: refreshPrivilegesList, } = useGetPrivilegeGroupsQuery();
    const { data: roleByIdData, error: roleByIdError, loading: roleByIdLoading, getRoleById, } = useGetRoleByIdLazyQuery(roleId);
    const { data: createRoleData, error: createRoleError, loading: createRoleLoading, createRole, } = useCreateRoleMutation();
    const { data: updateRoleData, error: updateRoleError, loading: updateRoleLoading, updateRole, } = useUpdateRoleMutation();
    useEffect(() => {
        if (isEditMode) {
            getRoleById();
        }
    }, [isEditMode]);
    useEffect(() => {
        if (isEditMode && privilegesList && roleByIdData) {
            const data = getFlattenPrivilegesList(privilegesList?.Data);
            setFilteredCheckboxData(privilegesList?.Data);
            setPrivilegeIds([...data]);
            setPreSelectedPrivilegeIds(roleByIdData?.Data?.privileges);
            setIsEditReady(true);
            setIsLoading(false);
        }
    }, [
        isEditMode,
        privilegesList,
        privilegesListLoading,
        roleByIdData,
        roleByIdLoading,
    ]);
    useEffect(() => {
        if (privilegesList) {
            const data = getFlattenPrivilegesList(privilegesList?.Data);
            setFilteredCheckboxData(privilegesList?.Data);
            setPrivilegeIds(data);
            setIsLoading(false);
        }
    }, [privilegesList, privilegesListLoading]);
    useEffect(() => {
        if (privilegesListError) {
            setIsLoading(false);
        }
    }, [privilegesListError, privilegesListLoading]);
    useEffect(() => {
        if (createRoleData?.Data) {
            successBannerMode(MODE.ADD);
            closeModal();
        }
    }, [createRoleData, createRoleLoading]);
    useEffect(() => {
        if (updateRoleData?.Data) {
            successBannerMode(MODE.UPDATE);
            closeModal();
        }
    }, [updateRoleData, updateRoleLoading]);
    useEffect(() => {
        if (!createRoleLoading && createRoleError) {
            setErrorMessage(t(TranslationsKeys.ROLE_NAME_ALREADY_EXISTS));
        }
    }, [createRoleError, createRoleLoading]);
    useEffect(() => {
        if (!updateRoleLoading && updateRoleError) {
            const errorCode = getErrorCode(updateRoleError);
            const msg = t(getTranslatedInfoForMessageCode(errorCode, TranslationsKeys.ROLE_NAME_ALREADY_EXISTS).summary);
            setErrorMessage(msg);
        }
    }, [updateRoleError, updateRoleLoading]);
    const filterPrivileges = (checkboxData) => {
        const data = getFlattenPrivilegesList(checkboxData);
        setFilteredCheckboxData(checkboxData);
        setPrivilegeIds(data);
    };
    const onSuccess = async (newData) => {
        setIsLoading(true);
        try {
            if (isEditMode) {
                await updateRole({ id: roleId, ...newData });
            }
            else {
                await createRole(newData);
            }
        }
        catch (err) {
            setIsLoading(false);
        }
    };
    return (React.createElement(React.Fragment, null, (!isEditMode || (isEditMode && isEditReady)) &&
        !!filteredCheckboxData.length && (React.createElement(CreateEditForm, { privilegeIds: privilegeIds, preSelectedPrivilegeIds: preSelectedPrivilegeIds, allCheckboxes: filteredCheckboxData, roleData: roleByIdData, message: errorMessage, isEditMode: isEditMode, isModalOpened: isModalOpened, setShowError: errorCB, closeModal: closeModal, onSuccess: onSuccess, sourceData: privilegesList?.Data, filterPrivileges: filterPrivileges }))));
};
//# sourceMappingURL=create-edit-modal.container.js.map